module.exports = __webpack_public_path__ + "img/logotipo_positivo.72ea98bf.png";